import * as yup from 'yup';

const validationSchema = () =>
  yup.object({
    notes: yup.string().nullable(),
    canceledAt: yup.date().nullable(),
  });

export default validationSchema;
